import { render, staticRenderFns } from "./DataMange.vue?vue&type=template&id=0b29592c"
import script from "./DataMange.vue?vue&type=script&lang=js"
export * from "./DataMange.vue?vue&type=script&lang=js"
import style0 from "./DataMange.vue?vue&type=style&index=0&id=0b29592c&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports